import React from 'react'

interface PriceProps {
  children: React.ReactNode;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
}

export function Price ({ children, prefix, suffix }: PriceProps) {
  return (
    <span>
      <span className='sr-only'>Price: </span>
      {!!prefix && (
        <span className='text-gray-800 body'>{prefix}</span>
      )}
      <span className='text-gray-800 heading-sm'>{children}</span>
      {!!suffix && (
        <span className='text-gray-800 body'>{suffix}</span>
      )}
    </span>
  )
}

Price.displayName = 'MarketplaceCard.Price'
